var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckFromWebsite(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2617"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2433",
    fill: "rgba(255,255,255,0)",
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-check",
    d: "M7.164 16.336l-5.749-5.748a.884.884 0 010-1.251l1.251-1.251a.884.884 0 011.251 0l3.872 3.872 8.294-8.294a.884.884 0 011.251 0l1.251 1.251a.884.884 0 010 1.251L8.414 16.336a.884.884 0 01-1.25 0z",
    fill: "#058181"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckFromWebsite);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconCheckFromWebsite.bb905854.svg";
export { MemoForwardRef as ReactComponent };